/* eslint-disable no-console */
/* eslint-disable max-len */
import React, { useState, useEffect, useRef, useContext } from 'react';
import $ from 'jquery';
import { get, isEmpty, map, uniqBy, filter, find } from 'lodash';
import { Box, Grid, Select, MenuItem } from '@mui/material';
import RadioButtonsGroup from './radio-button';
import RoTable from './ro-table';
import { isObjectEmpty } from '../../shared/helper';
import DesignGuidelines from './design-guildlines';
import {
  defaultModalOptions, defaultRoTableData, defaultUnitValues, defaultElementParameters,
  unitsForPressure_atm
} from '../../shared/constantVariable';
import Notification from '../../shared/notification-modal';
import { saveFormDataInLocalStorage } from '../../shared/feed-common-feature';
import { ro_options } from './ro-optins-constvar';
import { getBorderColor, decrypt_data } from '../../shared/utils';
import { ro_elem_shared_access, ro_elm_shared_access_stageZero } from '../ro-input/ro-element-access';
import { roUserbased_elemodel, setAllRoMachineModel, getAllRoMachineModel } from './ro-userbased-em';
import { convertUnitValues_pressure, convertUnitValues_flow } from '../../shared/conversion-helper/unitConversion';
import RoContext from './argo-input/contextcall';
import { roMachine } from '../../shared/api/url-helper';
import './ro.scss';
import { addInABFobj, updateOneKeyInABFObj, getAbValFactCheckedDict, getmyUniqElementModels_ud, getUserDictData } from '../userData';
import ElementAgeCalculator from './element_age_calculator';

const checkPressureUnit = {};
// eslint-disable-next-line
let myUniqElementdict;
let optionsABvalue = '0';

const RoFeedAnalysis = (props) => {
  const { dbTransactionDetails, updateElementParameters,
    roDetails, elementParameters, handleCloseNF, disabledStripperAndExplorerTab, setIsElementModelAccess,
    getnType, setElementParameters, isShowErrorMessage, setIsShowErrorMessage, onElementClick, isOptnAbValFctrToggled,
    setIsOptnAbValFctrToggled, roRadioABFactor, setRoRadioABFactor, translateObject, openRoForm, setOpenRoForm, downLoadFlowSheetRo, getIdRoForm, edges } = props;

  const handleSaveRocontextTableData = useContext(RoContext);
  const gridRef = useRef(); // Optional - for accessing Grid's API
  const [units, setUnits] = useState(defaultUnitValues);
  const [modalOption, setModalOption] = useState(defaultModalOptions);
  const [recovery, setRecovery] = useState(75.0);
  const [recyclePermeate, setRecyclePermeate] = useState(false);
  const [roTypes, setRoTypes] = useState(false);
  const [roInputDetails, setRoInputDetails] = useState({ splitPermeate: 0.00, permeateBypass: 0.00 });
  const [elements] = useState([]);
  const [enableRecycle, setEnableRecycle] = useState(true);
  const abFactor = roRadioABFactor;

  const systemUnits = JSON.parse(localStorage.getItem('system-units'));
  const pressure = get(systemUnits, 'pressure', 'atm');
  const [rowData, setRowData] = useState(defaultRoTableData()); // Set rowData to Array of Objects, one Object per Row

  handleSaveRocontextTableData.rowData = rowData;
  const colDefArr = [
    { tag: 'stage', hdata: translateObject('Stage'), disabled: true, datatype: 'number' },
    { tag: 'pressureVessels', hdata: translateObject('Pressure Vessels'), disabled: true, datatype: 'number' },
    { tag: 'elementsperVessel', hdata: translateObject('Elements per Vessel'), disabled: true, datatype: 'number' },
    { tag: 'application', hdata: translateObject('Application'), disabled: true, datatype: 'select' },
    { tag: 'elementGroup', hdata: translateObject('Element Group'), disabled: true, datatype: 'select' },
    { tag: 'elementModel', hdata: translateObject('Element Model'), disabled: true, datatype: 'select' },
    { tag: 'fluxAnnual', hdata: `${abFactor === '0' ? translateObject('Flux Annual % Change') : translateObject('A-Value Factor')}`, disabled: true, datatype: 'number' },
    { tag: 'saltPassageAnnual', hdata: `${abFactor === '0' ? translateObject('Salt Passage Annual % Change') : translateObject('B-Value Factor')}`, disabled: true, datatype: 'number' },
    { tag: 'permeatePressure', hdata: `${translateObject('Permeate Pressure')} (${pressure})`, disabled: true, datatype: 'number' },
    { tag: 'interStagePressureLoss', hdata: `${translateObject('InterStage Pressure Loss')} (${pressure})`, disabled: true, datatype: 'number' },
    { tag: 'interStageBoostPressure', hdata: `${translateObject('InterStage Boost Pressure')} (${pressure})`, disabled: true, datatype: 'number' },
    { tag: 'boostEnergyEfficiency', hdata: translateObject('Boost Energy Efficiency %'), disabled: true, datatype: 'number' },
    { tag: 'elementInfo', hdata: translateObject('Element Info'), disabled: null, datatype: 'button', className: 'ros-btn' }
  ];

  let curRoUnitopName;

  if (abFactor === '0') {
    colDefArr.splice(6, 0, {
      tag: 'elementAge',
      hdata: translateObject('Element Age (yr)'),
      datatype: 'number',
      disabled: true,
      st: 60
    });
  }
  const [option, setOption] = useState(ro_options);

  // Multi Ro machine
  const [roMachineModel, setRoMachineModel] = useState([]);
  // RO mac. Dropdown item
  const [roMachineDdItem, setRoMachineDdItem] = useState([]);
  // RO-Machine-Model Dropdown ka Value
  const [roModel, setRoModel] = useState('');
  // Selected RO-Machine-Model Dropdown ka dict
  const [currRoM, setCurrRoM] = useState('');

  const elementsDict = get(dbTransactionDetails, 'elements_dict', {});
  let arrData = map(elementsDict, (row) => row);  // 333
  // sort the element in asc. order based on EID value
  arrData.sort((a, b) => a.EID - b.EID); // 333 elem
  // GB-2659 -start
  // In RO form, if the users don't have access to any element model under a given element group,
  // then that element group should be hidden. Eg: NF PA--> Seawater NF
  const userbased_elementModel = getmyUniqElementModels_ud(); // filter all the Element model for which user having access  150
  arrData = arrData.filter(item => userbased_elementModel.includes(item.strModel.replace(/[-, _()/.%]/g, '')));
  // GB-2659 End

  const setApplnDropdn = (row) => {
    const dummyOption = option;
    const uniqApplications = uniqBy(arrData, 'SelectionA');
    // const uniqApplnDDvalues = ['', ...map(uniqApplications, 'SelectionA')];
    const uniqApplnDDvalues = ['', 'NF PA'];
    dummyOption[row].application = uniqApplnDDvalues;
    setOption(dummyOption);
  };
  // design guide line start
  const [visibleDG, setVisibleDG] = useState(false);
  const [visibleEAC, setVisibleEAC] = useState(false);
  const handleCloseDG = () => {
    setVisibleDG(false);
    localStorage.removeItem('previousUnits');
  };
  const handleCloseEAC = () => {
    setVisibleEAC(false);
    localStorage.removeItem('previousUnits');
  };
  const ElementAgeCalculatorfunc = () => {
    setVisibleEAC(true);
  };
  const designGuidline = () => {
    setVisibleDG(true);
  };
  // design guide line end

  const setElemGrpDropdn = (row, value) => {
    let elementGroup = filter(arrData, { SelectionA: value });
    elementGroup = elementGroup.filter(item => [9, 10, 23, 24, 37, 38].includes(item.nType));
    let uniqElementGroup = uniqBy(elementGroup, 'SelectionB');
    uniqElementGroup = uniqElementGroup.filter(item => [9, 10, 23, 24, 37, 38].includes(item.nType));
    const uniqElemGrpDDvalues = ['', ...map(uniqElementGroup, 'SelectionB')];
    option[row].elementGroup = uniqElemGrpDDvalues;
  };

  const setElemModelDropdn = (row, applnValue, eleGrpvalue) => {
    let elementModel = filter(arrData, { SelectionA: applnValue, SelectionB: eleGrpvalue });
    elementModel = elementModel.filter(item => [9, 10, 23, 24, 37, 38].includes(item.nType));
    const userbased_elementModel = roUserbased_elemodel(elementModel, dbTransactionDetails.users_dict);
    option[row].elementModel = userbased_elementModel;
  };
  const updateMinandMaxValue = () => {
    const resRange = { min: 0, max: 68.05 };
    const previous_pressure_unit = 'atm';
    resRange.min = Number(convertUnitValues_pressure(resRange.min, previous_pressure_unit, pressure));
    resRange.max = Number(convertUnitValues_pressure(resRange.max, previous_pressure_unit, pressure));
    return resRange;
  };

  const handleAfterBlur = (evt) => {
    const { id, value } = evt.target;
    const flag = id.indexOf('_', 9);
    const row = Number(id.substring(9, flag)) - 1;    // row Number
    const col = Number(id.substring(flag + 1)) - 1; // col number
    const filteredData = rowData;                 // grid data
    const curRow = filteredData[row];             // curr row data
    const prevRow = filteredData[row - 1] || {};

    const curColname = colDefArr[col].tag;
    // we are removing the condition for checking for application, elementGroup and elementModel -->Kranthi
    if (((prevRow.pressureVessels === 0 ||
      prevRow.pressureVessels === '' ||
      prevRow.elementsperVessel === 0 ||
      prevRow.elementsperVessel === '') && Number(value) !== 0)
    ) {
      if (curRow.stage > 1) {
        evt.preventDefault();
        setModalOption({ // show warning
          ...defaultModalOptions,
          visible: true,
          title: 'Warning',
          message: translateObject('Please populate the previous row(s) !'),
          yesOrNo: false,
          onNo: () => setModalOption(defaultModalOptions)
        });
      }
    }
    if (curColname === 'elementAge' && value !== '' && value !== 0) {
      if (value < 0 || value > 10) {
        evt.preventDefault();
        setModalOption({
          ...defaultModalOptions,
          visible: true,
          title: 'Warning',
          message: translateObject('Element Age (yr) must be in the range 0-10'),
          yesOrNo: false,
          onNo: () => setModalOption(defaultModalOptions)
        });
        curRow.elementAge = 10;
      } else {
        curRow.elementAge = Number(value);
      }
    }

    if (curColname === 'permeatePressure' && value !== '' && value !== 0) {
      const resRange = updateMinandMaxValue(value);
      if (value < resRange.min || value > resRange.max) {
        evt.preventDefault();
        setModalOption({
          ...defaultModalOptions,
          visible: true,
          title: 'Warning',
          message: `Permeate Pressure must be in the range ${resRange.min}-${(resRange.max).toFixed(2)} (${pressure})`,
          yesOrNo: false,
          onNo: () => setModalOption(defaultModalOptions)
        });
        curRow.permeatePressure = resRange.max;
      } else {
        curRow.permeatePressure = Number(value);
      }
    }

    if (curColname === 'interStagePressureLoss' && value !== '' && value !== 0) {
      const resRange = updateMinandMaxValue(value);
      if (value < resRange.min || value > resRange.max) {
        evt.preventDefault();
        setModalOption({
          ...defaultModalOptions,
          visible: true,
          title: 'Warning',
          message: `InterStage Pressure Loss must be in the range ${resRange.min}-${(resRange.max).toFixed(2)} (${pressure})`,
          yesOrNo: false,
          onNo: () => setModalOption(defaultModalOptions)
        });
        curRow.interStagePressureLoss = resRange.max;
      } else {
        curRow.interStagePressureLoss = Number(value);
      }
    }
    // Validation added by Abhishek on 8th-Dec-23
    if (curColname === 'boostEnergyEfficiency') {
      if (Number(value) < 10 || Number(value) > 100) {
        evt.preventDefault();
        if (Number(curRow.interStageBoostPressure) > 0) {
          setModalOption({
            ...defaultModalOptions,
            visible: true,
            title: 'Warning',
            message: translateObject('Boost Energy Efficiency % must be in the range 10-100'),
            yesOrNo: false,
            onNo: () => setModalOption(defaultModalOptions)
          });
        }

        if (Number(curRow.interStageBoostPressure) === 0)
          curRow.boostEnergyEfficiency = '0.00';
        else
          curRow.boostEnergyEfficiency = 70;

      } else {
        curRow.boostEnergyEfficiency = Number(value);
      }
    }
    if (curRow.stage === filteredData[row].stage) {
      filteredData[row].pressureVessels = Number(curRow.pressureVessels);
      filteredData[row].elementsperVessel = Number(curRow.elementsperVessel);
      filteredData[row].application = curRow.application;
      filteredData[row].elementGroup = curRow.elementGroup;
      filteredData[row].elementModel = curRow.elementModel;
      filteredData[row].elementAge = Number(curRow.elementAge).toFixed(2);
      filteredData[row].fluxAnnual = Number(curRow.fluxAnnual).toFixed(2);
      filteredData[row].saltPassageAnnual = Number(curRow.saltPassageAnnual).toFixed(2);
      filteredData[row].permeatePressure = Number(curRow.permeatePressure).toFixed(2);
      filteredData[row].interStagePressureLoss = Number(curRow.interStagePressureLoss).toFixed(2);
      filteredData[row].interStageBoostPressure = Number(curRow.interStageBoostPressure).toFixed(2);
      filteredData[row].boostEnergyEfficiency = Number(curRow.boostEnergyEfficiency).toFixed(2);
      filteredData[row].elementModelNumber = filteredData[row].elementModel ? (arrData.find(item => item.strModel === filteredData[row].elementModel)).nElementNumber : '';
    }
    if (Number(row) === 0) {
      filteredData[row].interStageBoostPressure = '';
      filteredData[row].boostEnergyEfficiency = '';
    }
    setRowData(filteredData);
    const loc = JSON.parse(localStorage.getItem('ro-stage-data')) || {};
    const locData = { ...loc, [`stage${curRow.stage}`]: curRow };
    localStorage.setItem('ro-stage-data', JSON.stringify(locData));

  }; //  end of handleAfterBlur()

  function clearForm() {
    const clearFormArrData = [];
    for (let i = 1; i < 9; i += 1) {
      clearFormArrData.push({
        stage: i,
        pressureVessels: 0,
        elementsperVessel: 0,
        application: '',
        elementGroup: '',
        elementModel: '',
        elementAge: 0.00,
        fluxAnnual: 0.00,
        saltPassageAnnual: 0.00,
        permeatePressure: 0.00,
        interStageBoostPressure: i === 1 ? '' : 0.00,
        boostEnergyEfficiency: i === 1 ? '' : 0.00,
        interStagePressureLoss: 0.00
      });
    }
    setRowData([...clearFormArrData]);
    $('.ro-table_container input').attr('disabled', true);
    $('.ro-table_container select').attr('disabled', true);
    $('.ro-table_container .row_1 input').attr('disabled', null);
    $('.ro-table_container .row_1 select').attr('disabled', null);
    $('.ro-table_container #input_num1_1').attr('disabled', true);
    $('.ro-table_container #input_num1_12').attr('disabled', true);
    // $('.ro-table_container #input_num1_13').attr('disabled', true);
    $('.ro-table_container select').css({ 'min-width': '8vw', 'max-width': '8vw' }); // reduce wisth of dropdowns to get space for remaing elements
  }

  const onValueChange = (e) => {
    setIsShowErrorMessage(true);
    localStorage.setItem('globalExitBtn', 'true');
    const { id, value } = e.target;
    const flag = id.indexOf('_', 9);
    const row = Number(id.substring(9, flag)) - 1;    // row Number
    const col = Number(id.substring(flag + 1)) - 1; // col number
    const filteredData = rowData;                 // grid data
    const curRow = filteredData[row];             // curr row data
    const curColname = colDefArr[col].tag;
    const prevCol = colDefArr[col - 1].tag;
    const prevRow = filteredData[row - 1] || {};
    if (curColname === 'pressureVessels') {
      if (Number(value) < 0 || Number(value) > 999) {
        e.preventDefault();
        setModalOption({
          ...defaultModalOptions,
          visible: true,
          title: 'Warning',
          message: translateObject('Pressure Vessels must be in the range 0-999'),
          yesOrNo: false,
          onNo: () => setModalOption(defaultModalOptions)
        });
        curRow.pressureVessels = 0;
      } else if (value === '0' || value === 0 || value === '') {
        curRow.elementsperVessel = 0;
        curRow.application = '';
        curRow.elementGroup = '';
        curRow.elementModel = '';
        curRow.elementAge = 0.00;
        curRow.fluxAnnual = 0.00;
        curRow.saltPassageAnnual = 0.00;
        curRow.permeatePressure = 0.00;
        curRow.interStagePressureLoss = 0.00;
        curRow.interStageBoostPressure = Number(row) === 0 ? '' : 0.00;
        curRow.boostEnergyEfficiency = Number(row) === 0 ? '' : 0.00;
        curRow.elementModelNumber = 0.00;
        option[row].application = [];
        option[row].elementGroup = [];
        option[row].elementModel = [];
        if (Number(filteredData[row + 1].pressureVessels) !== 0) {
          $(`.ro-table_container .row_${row + 2} input`).attr('disabled', null);
          $(`.ro-table_container .row_${row + 2} select`).attr('disabled', null);
          $(`.ro-table_container #input_num${row + 2}_1`).attr('disabled', true);
        }
      } if (value === '');
      else {
        curRow.pressureVessels = Number(value);
      }
    }
    if (curColname === 'elementsperVessel') {
      if (value < 0 || value > 8) {
        e.preventDefault();
        setModalOption({
          ...defaultModalOptions,
          visible: true,
          title: 'Warning',
          message: translateObject('Elements per Vessel must be in the range 0-8'),
          yesOrNo: false,
          onNo: () => setModalOption(defaultModalOptions)
        });
        curRow.elementsperVessel = 8;
      } else if (Number(value) === 0 || value.trim() === '') {
        curRow.application = '';
        curRow.elementGroup = '';
        curRow.elementModel = '';
        curRow.elementModelNumber = '';
        curRow.saltPassageAnnual = 0;
        curRow.fluxAnnual = 0;
        option[row].application = [];
        option[row].elementGroup = [];
        option[row].elementModel = [];
        if (Number(filteredData[row + 1].pressureVessels) === 0) {
          $(`.ro-table_container .row_${row + 2} input`).attr('disabled', true);
          $(`.ro-table_container .row_${row + 2} select`).attr('disabled', true);
        }
      } else {
        // We are enabling the next pressure vessel value and elements per vessel value by clicking on the elements per vessel value. ------>Kranthi
        $(`.ro-table_container .row_${row + 2} input`).attr('disabled', null);
        $(`.ro-table_container .row_${row + 2} select`).attr('disabled', null);
        $(`.ro-table_container #input_num${row + 2}_1`).attr('disabled', true);
        if (Number(curRow.stage) > 1) {
          curRow.application = prevRow.application;
          curRow.elementGroup = prevRow.elementGroup;
          curRow.elementModel = prevRow.elementModel;
          curRow.elementModelNumber = prevRow.elementModelNumber; // added by Abhishek on 19-Jan for nElementNumber
          curRow.fluxAnnual = prevRow.fluxAnnual;
          curRow.saltPassageAnnual = prevRow.saltPassageAnnual;
          $(`.ro-table_container .row_${row + 2} input`).attr('disabled', null);
          $(`.ro-table_container .row_${row + 2} select`).attr('disabled', null);
          $(`.ro-table_container #input_num${row + 2}_1`).attr('disabled', true);
          setApplnDropdn(row);
          setElemGrpDropdn(row, prevRow.application);
          setElemModelDropdn(row, prevRow.application, prevRow.elementGroup);
        }
        if ((curRow[prevCol] <= 0 || curRow[prevCol] === '') && col <= 6) {
          setModalOption({
            ...defaultModalOptions,
            visible: true,
            title: 'Warning',
            message: `${colDefArr[col - 1].hdata} must not be empty`,
            yesOrNo: false,
            onNo: () => setModalOption(defaultModalOptions)
          });
          curRow.elementsperVessel = 0;
        } else {
          curRow.elementsperVessel = Number(value);
          setApplnDropdn(row);
        }
      }
    }
    if (curColname === 'application' && value.trim() !== '') {
      curRow.application = value;
      setElemGrpDropdn(row, value);
      curRow.elementGroup = '';
      curRow.elementModel = '';
      curRow.elementModelNumber = ''; // added by Abhishek on 19-Jan for nElementNumber
      option[row].elementModel = [];

      if (curRow.application === '') {
        curRow.fluxAnnual = Number(0.00);
        curRow.saltPassageAnnual = Number(0.00);
      } else if (Number(abFactor) === 0) {
        // @sudarsana this is display the default values based on condtion by tracesing the paths
        const flow_sheet_dict_raw = localStorage.getItem('flow_sheet_dict');
        const flow_sheet_dict = flow_sheet_dict_raw ? JSON.parse(flow_sheet_dict_raw) : null;

        const getedgeForm = edges.filter(e => e.target === getIdRoForm);
        const getWasteConnectionForm = getedgeForm?.[0]?.sourceHandle ?? null;

        const gethppumpTarget = edges.filter(
          e => e.target === `hppump_${getIdRoForm?.split('_')?.[1]}`
        );
        const getWasteConnectionFormRO_HP = gethppumpTarget?.[0]?.sourceHandle ?? null;

        const hpSource = gethppumpTarget?.[0]?.source; // guarded
        const getWasterROERD = hpSource ? edges.filter(e => e.target === hpSource) : [];
        const getWasteConnectionFormRO_ERD = getWasterROERD?.[0]?.sourceHandle ?? null;
        if ((getWasteConnectionForm === 'd' || getWasteConnectionFormRO_HP === 'd' || getWasteConnectionFormRO_ERD === 'd')) {
          curRow.fluxAnnual = Number(5.00);
          curRow.saltPassageAnnual = Number(7.00);
          localStorage.removeItem('flow_sheet_dict_nfwastage');
        }
        else if ((flow_sheet_dict && flow_sheet_dict.Type !== '1 Pass' && getIdRoForm !== 'nfPump_1')) {
          curRow.fluxAnnual = Number(2.00);
          curRow.saltPassageAnnual = Number(2.00);
        } else if (getIdRoForm !== 'nfPump_1' && (getWasteConnectionForm === 'c' || getWasteConnectionFormRO_HP === 'c')) {
          curRow.fluxAnnual = Number(2.00);
          curRow.saltPassageAnnual = Number(2.00);
        }
        else {
          curRow.fluxAnnual = Number(5.00);
          curRow.saltPassageAnnual = Number(7.00);
        }
      } else {
        curRow.fluxAnnual = Number(1.00);
        curRow.saltPassageAnnual = Number(1.00);
      }
    }
    if (curColname === 'elementGroup' && value.trim() !== '') {
      curRow.elementGroup = value;
      setElemModelDropdn(row, curRow[prevCol], value);
    }
    if (curColname === 'elementModel' && value.trim() !== '') {
      curRow.elementModel = value;
      const elementsDict = get(dbTransactionDetails, 'elements_dict', {});
      const arrData = map(elementsDict, (row) => row);
      const currStage = find(arrData, { SelectionA: curRow.application, SelectionB: curRow.elementGroup, strModel: curRow.elementModel });
      curRow.elementModelNumber = curRow.elementModel ? (arrData.find(item => item.strModel === curRow.elementModel)).nElementNumber : ''; // added by Abhishek on 19-Jan for nElementNumber
      getnType(currStage.nType);
      setElementParameters(currStage);
    }
    if ((curColname === 'fluxAnnual' || curColname === 'saltPassageAnnual') && value.trim() !== '') {
      const curUnopName = roDetails.id;
      updateOneKeyInABFObj(curUnopName, false); // if either of any cell is clicked then update to dict
      // false means -> take the user defined value
      //  true means -> take the default value
    }
    // Validaton at interStageBoostPressure by Abishek on 8-Dec-23
    if (curColname === 'interStageBoostPressure') {
      if (Number(curRow.interStageBoostPressure) > 0)
        curRow.boostEnergyEfficiency = '70';
      if (Number(curRow.interStageBoostPressure) === 0)
        curRow.boostEnergyEfficiency = '0.00';
    }

    if (curColname === 'boostEnergyEfficiency' && curRow.interStageBoostPressure <= 0) {
      e.preventDefault();
      setModalOption({
        ...defaultModalOptions,
        visible: true,
        title: 'Warning',
        message: `${colDefArr[col - 1].hdata} must not be empty`,
        yesOrNo: false,
        onNo: () => setModalOption(defaultModalOptions)
      });
      curRow.interStageBoostPressure = Number(0.00);
      curRow.boostEnergyEfficiency = Number(0.00);
    }
    if (Number(row) === 0) {
      curRow.interStageBoostPressure = '';
      curRow.boostEnergyEfficiency = '';
    }
    // reset ro machine
    // added by chandrashekar GB-2958 if condition only previousaly setRoModel(''); setCurrRoM(''); outside the if block.
    if (['pressureVessels', 'elementsperVessel', 'application', 'elementGroup', 'elementModel'].indexOf(curColname) >= 0) {
      setRoModel('');
      setCurrRoM('');
    }
    disabledStripperAndExplorerTab();
  }; // end of onValueChange()

  function fetchFormDatafromLocalStorage(roRecord) {
    if (isObjectEmpty(roRecord)) {
      updateElementParameters(roRecord.elementParameters || {});
      setRecyclePermeate(roRecord.recyclePermeate || false);
      setRoTypes(roRecord.roTypes || false);
      setRecovery(roRecord.recovery || 0.0);
      setRoInputDetails(roRecord.roInputDetails || { splitPermeate: 0.00, permeateBypass: 0.00 });
      // for ro machine
      if (roRecord.roMachine) {
        setRoModel(roRecord.roMachine.ROMachineModel);
        setCurrRoM(roRecord.roMachine);
      }// for ro machine end
      clearForm();
      const griddata = roRecord['grid-data'];
      setRowData(roRecord['grid-data']);
      let row = 0;
      while (row < 8) {
        if (Number(griddata[row].pressureVessels) !== 0) {
          $(`.ro-table_container .row_${row + 2} input`).attr('disabled', null);
          $(`.ro-table_container .row_${row + 2} select`).attr('disabled', null);
          $(`.ro-table_container #input_num${row + 2}_1`).attr('disabled', true);
          setApplnDropdn(row);
          setElemGrpDropdn(row, griddata[row].application);
          setElemModelDropdn(row, griddata[row].application, griddata[row].elementGroup);
          // checking the abFactor
          if (abFactor === '0') { // if 0 -> then check both value is 1 n 1 that means user din't update the value, so update it to default
            // convert fluxAnnual & saltPassageAnnual in to number to compare
            if (getAbValFactCheckedDict()[curRoUnitopName]) { // get the abvalue factor obj.current unit op name -> it will either true or false
              griddata[row].fluxAnnual = '5.00';
              griddata[row].saltPassageAnnual = '7.00';
            }
          } else {  // eslint-disable-next-line
            if (getAbValFactCheckedDict()[curRoUnitopName]) {
              griddata[row].fluxAnnual = '1.00';
              griddata[row].saltPassageAnnual = '1.00';
            }
          }

        } else {
          break;
        }
        row += 1;
      }
    } else {
      updateElementParameters({});
      setRecyclePermeate(false);
      setRoTypes(false);
      setRecovery(75.0);
      setRoInputDetails({ splitPermeate: 0.00, permeateBypass: 0.00 });
      clearForm();
      // reset ro machine
      setRoModel('');
      setCurrRoM('');
    }
  }

  const getElemPropInfoOnClickEM = () => {
    $('#input_num1_6, #input_num2_6, #input_num3_6, #input_num4_6, #input_num5_6, #input_num6_6, #input_num7_6, #input_num8_6').focus((event) => {
      const data = event.target.id.split('_');
      const val = data[data.length - 2].replace(/[a-zA-Z]/g, '');
      const currStage = find(arrData, { SelectionA: $(`#input_num${val}_4`).val(), SelectionB: $(`#input_num${val}_5`).val(), strModel: $(`#input_num${val}_6`).val() });
      if (currStage && currStage.nType)
        getnType(currStage.nType);
      setElementParameters(currStage);
    });
  };

  const onRoMDropdownChange = (ev) => {
    if (!(ev.target.value === 'No options')) {
      setRoModel(ev.target.value);
      const currRoMachineModeldict = roMachineModel[ev.target.value];
      setCurrRoM(currRoMachineModeldict);
      localStorage.setItem('globalExitBtn', 'true');
      const currRoMEmodel = currRoMachineModeldict.nElementNumber;
      const selectedROMElementInfo = myUniqElementdict.find(item => item.nElementNumber === currRoMEmodel) || 0; // eslint-disable-next-line
      // update ro-stage-data
      if (selectedROMElementInfo) {
        const rom_stage_data = [];
        for (let i = 0; i < 8; i += 1) {
          rom_stage_data.push({
            'stage': i + 1,
            'pressureVessels': 0,
            'elementsperVessel': 0,
            'application': '',
            'elementGroup': '',
            'elementModel': '',
            'elementAge': '0.00',
            'fluxAnnual': '0.00',
            'saltPassageAnnual': '0.00',
            'permeatePressure': '0.00',
            'interStageBoostPressure': i === 0 ? '' : '0.00',
            'boostEnergyEfficiency': i === 0 ? '' : '0.00',
            'interStagePressureLoss': '0.00',
          });
        }

        for (let i = 0; i < 4; i += 1) {
          if (Number(currRoMachineModeldict[`Pass1_Housing_stg${i + 1}`]) !== 0) {
            rom_stage_data[i].pressureVessels = currRoMachineModeldict[`Pass1_Housing_stg${i + 1}`];
            rom_stage_data[i].elementsperVessel = currRoMachineModeldict[`Pass1_Elemnts_stg${i + 1}`];
            rom_stage_data[i].application = selectedROMElementInfo.SelectionA;
            rom_stage_data[i].elementGroup = selectedROMElementInfo.SelectionB;
            rom_stage_data[i].elementModel = selectedROMElementInfo.strModel;
            rom_stage_data[i].fluxAnnual = abFactor === '0' ? '5.00' : '1.00'; // value based on abFactor
            rom_stage_data[i].saltPassageAnnual = abFactor === '0' ? '7.00' : '1.00';

            rom_stage_data[i].elementModelNumber = rom_stage_data[i].elementModel ? (arrData.find(item => item.strModel === rom_stage_data[i].elementModel)).nElementNumber : ''; // added by Abhishek on 19-Jan for nElementNumber
          }
        }
        const griddata = rom_stage_data;
        setRowData(rom_stage_data);
        let row = 0;
        while (row < 8) {
          if (Number(griddata[row].pressureVessels) !== 0) {
            $(`.ro-table_container .row_${row + 2} input`).attr('disabled', null);
            $(`.ro-table_container .row_${row + 2} select`).attr('disabled', null);
            $(`.ro-table_container #input_num${row + 2}_1`).attr('disabled', true);
            setApplnDropdn(row);
            setElemGrpDropdn(row, griddata[row].application);
            setElemModelDropdn(row, griddata[row].application, griddata[row].elementGroup);
          } else {
            break;
          }
          row += 1;
        }
        setRowData([...Object.values(rom_stage_data)]);
        // disable the stream data, explorer, errors and warnings any changes of RO Machine model disabledStripperAndExplorerTab();
        disabledStripperAndExplorerTab();
        setIsShowErrorMessage(true);
      }
      else {
        setModalOption({
          ...defaultModalOptions,
          visible: true,
          title: 'Warning',
          message: 'You don\'t have access',
          yesOrNo: false,
          onNo: () => setModalOption(defaultModalOptions)
        });
      }

    }
  };

  const roMachNtwkCallData = (decData) => {
    const roMachine = Object.values(decData.romachine_dict);

    const currUserEmail = sessionStorage.getItem('user_email');
    // eslint-disable-next-line
    let filteredRoMach;
    // decData.romachine_dict;
    // const userExistInCatdict = Object.keys(decData.elements_user_details).includes(currUserEmail);

    const userDistData = getUserDictData();
    const userExistInCatdict = Object.keys(userDistData).includes(currUserEmail);

    if (userExistInCatdict) {
      let isROMachineAccess = userDistData[currUserEmail].ROMachine || 0;
      isROMachineAccess = isROMachineAccess.split(',').includes('1');
      filteredRoMach = isROMachineAccess ? roMachine : roMachine.filter(item => item.PassCode === 0);
    } else {
      filteredRoMach = roMachine.filter(item => item.PassCode === 0);
    }

    const filteredRoMach_dict = {};
    // for (let i = 0; i < filteredRoMach.length; i += 1) {
    //   filteredRoMach_dict[filteredRoMach[i].ROMachineModel] = filteredRoMach[i];
    // }
    // Set Dropdown Item
    // const resKey = Object.keys(filteredRoMach_dict).sort();
    // added by chandrashekhar GB-2910 In RO form ----> RO Machine Array Configuration drop down should show RO Machines sorted based on ID START
    filteredRoMach = Object.values(filteredRoMach).sort((a, b) => {
      return a.ROID2 > b.ROID2 ? 1 : -1;
    });
    // create data key value pair
    filteredRoMach.map((ele) => {
      filteredRoMach_dict[ele.ROMachineModel] = ele;
    });
    const resKey = Object.keys(filteredRoMach_dict);
    // added by chandrashekhar GB-2910 In RO form ----> RO Machine Array Configuration drop down should show RO Machines sorted based on ID END
    setRoMachineDdItem(resKey);
    // Set filter machine only
    setRoMachineModel(filteredRoMach_dict);
    const uniqEModel = uniqBy(arrData, 'strModel');
    myUniqElementdict = uniqEModel;
  };

  const getRoMachineModelFun = () => {

    roMachine().then((res) => {
      const decData = decrypt_data(res.data);
      setAllRoMachineModel(decData); // set data
      // and update state
      roMachNtwkCallData(decData);
    })
      .catch(() => {
        setModalOption({
          ...defaultModalOptions,
          visible: true,
          title: 'Warning',
          message: translateObject('Failed to fetch Ro Machine record'),
          yesOrNo: false,
          onNo: () => setModalOption(defaultModalOptions)
        });
      });
  }; // fun end

  useEffect(() => {  // for AB Value factor on saved file by Abhishek
    // let abFactRow;
    // // trying to store initial ab value factor
    // if (Number(abFactor) === 1) {
    //   $('#input_num1_13').val('');
    //   $('.ros-btn').val('');
    //   $('#input_num1_13').removeAttr('value');
    //   $('.ros-btn').removeAttr('value');

    //   abFactRow = rowData.map((item) => {
    //     if (item.application) {
    //       item.fluxAnnual = '1.00';
    //       item.saltPassageAnnual = '1.00';
    //       item.elementAge = '0.00';
    //     }
    //     return item;
    //   });
    // } else if (Number(abFactor) === 0) {
    //   abFactRow = rowData.map((item) => {
    //     if (item.application) {
    //       item.fluxAnnual = '5.00';
    //       item.saltPassageAnnual = '7.00';
    //     }
    //     return item;
    //   });
    // }
    // setRowData(abFactRow);
    if (Number(abFactor) === 1) {
      $('#input_num1_13').val('');
      $('.ros-btn').val('');
      $('#input_num1_13').removeAttr('value');
      $('.ros-btn').removeAttr('value');
    }
    /**
     *  Create useState const [openRoForm, setOpenRoForm] = useState(false); default value is false
     * Open we Open any RO-form By defalut call this useEffect and update the value `fluxAnnual`,
     * `saltPassageAnnual` and `elementAge` value but their is no need to update the value while
     * opening form, so i had use the use state variable `openRoForm` when change the radio
     * button call this useEffect and change the all RO-form `fluxAnnual`, `saltPassageAnnual`
     * and `elementAge` value.
     */

    if (openRoForm) {
      // get the data form localStorage `ro-dict` data.
      const localData_updated = get(JSON.parse(localStorage.getItem('ro-dict')), 'ro', {});
      const { id } = roDetails;
      Object.values(localData_updated).map((element) => {
        element['grid-data'].map((ele) => {
          if (ele.application) {
            ele.fluxAnnual = Number(abFactor) === 1 ? '1.00' : '5.00';
            ele.saltPassageAnnual = Number(abFactor) === 1 ? '1.00' : '7.00';
            ele.elementAge = Number(abFactor) === 1 ? '0.00' : ele.elementAge;
          }
          return ele;
        });
        return element;
      });
      // if value is not exits localData_updated[id] set rowData value abFactRow othewise
      // set the rowdata localData_updated[id]['grid-data'];
      const abFactRow = rowData.map((item) => {
        if (item.application) {
          item.fluxAnnual = Number(abFactor) === 1 ? '1.00' : '5.00';
          item.saltPassageAnnual = Number(abFactor) === 1 ? '1.00' : '7.00';
          item.elementAge = Number(abFactor) === 1 ? '0.00' : item.elementAge;
        }
        return item;
      });
      setRowData(abFactRow);
      // after updating the value set localStorage `ro-dict` data
      localStorage.setItem('ro-dict', JSON.stringify({ ro: localData_updated }));
      setOpenRoForm(false);
    }
  }, [abFactor]);

  useEffect(() => {
    // for AB Value factor on saved file commnet
    // get ro machine
    if (getAllRoMachineModel()) { // if data is not there then call api & save data (else part )
      roMachNtwkCallData(getAllRoMachineModel());
    } else {
      getRoMachineModelFun();
    }
    // getElement Parameter/Info OnClick of Element Model for the footer section
    getElemPropInfoOnClickEM();

    if (!isEmpty(JSON.parse(localStorage.getItem('system-units')))) {
      setUnits(JSON.parse(localStorage.getItem('system-units')));
      checkPressureUnit[roDetails.id] = JSON.parse(localStorage.getItem('system-units')).pressure ?
        JSON.parse(localStorage.getItem('system-units')).pressure : 'atm';
    } else {
      checkPressureUnit[roDetails.id] = units.pressure ? units.pressure : 'atm';
    }
    if (isObjectEmpty(roDetails)) {
      const { id } = roDetails;
      curRoUnitopName = roDetails.id;
      // update value to false only when value is not true
      if (!(getAbValFactCheckedDict()[curRoUnitopName])) {
        addInABFobj(roDetails.id, false); // add current unit op id in the abfactor dict
      }
      const localData = get(JSON.parse(localStorage.getItem('ro-dict')), 'ro', {});
      ro_elm_shared_access_stageZero(localData);
      const localData_updated = get(JSON.parse(localStorage.getItem('ro-dict-temp')), 'ro', {});
      if (isObjectEmpty(localData_updated)) {
        const roRecord = localData_updated[id];
        fetchFormDatafromLocalStorage(roRecord);
        const obj = {};
        if (roRecord) {
          for (let i = 0; i < 8; i += 1) {
            obj[`stage${roRecord['grid-data'][i].stage}`] = roRecord['grid-data'][i];
          }
          localStorage.setItem('ro-stage-data', JSON.stringify(obj));
          // Reset Element Paramater dict. to default one
          setElementParameters(defaultElementParameters);
        }
      } else {
        clearForm();
      }
    }
  }, [roDetails]);

  const handleChangeInput = (event) => {
    const { name, value } = event.target;
    if (value > 1000 || value < 0) {
      setModalOption({
        ...defaultModalOptions,
        visible: true,
        title: 'Warning',
        message: `${name} must be in the range 0-1000`,
        yesOrNo: false,
        onNo: () => setModalOption(defaultModalOptions)
      });
      setRoInputDetails(roInputDetails);
    } else {
      setRoInputDetails({ ...roInputDetails, [name]: Number(value) });
      setIsShowErrorMessage(true);
      localStorage.setItem('globalExitBtn', 'true');

      disabledStripperAndExplorerTab();
    }
  };
  const blurInputval = () => {
    const data = { splitPermeate: 0, permeateBypass: 0 };
    data.splitPermeate = Number(roInputDetails.splitPermeate).toFixed(2);
    data.permeateBypass = Number(roInputDetails.permeateBypass).toFixed(2);
    setRoInputDetails(data);
  };

  const handleChangeROTypes = (e) => {
    setRoTypes(e.target.checked);
    setRoInputDetails({ splitPermeate: 0.00, permeateBypass: 0.00 });
    disabledStripperAndExplorerTab();
  };

  const handleRecyclePermeate = (event) => {
    setIsShowErrorMessage(true);
    localStorage.setItem('globalExitBtn', 'true');

    setRecyclePermeate(event.target.checked);
    disabledStripperAndExplorerTab();
  };

  const showErrorMessage = () => {
    setModalOption({
      ...defaultModalOptions,
      visible: true,
      yesOrNo: false,
      type: 'error',
      title: 'Error',
      message: translateObject('Enter valid data in Pressure Vessels, Elements Per Vessel and Element Type'),
      onYes: () => handleCloseNF(),
      onNo: () => setModalOption(defaultModalOptions)
    });
  };

  const enableRecyclePermeate = async () => {
    const record = rowData;
    const stagedData = record.filter((obj) => obj.pressureVessels !== 0);
    if (stagedData.length > 1) {
      setEnableRecycle(false);
    } else {
      setEnableRecycle(true);
      setRecyclePermeate(false);
    }
  };

  const validateFields = (stagedData) => {
    return stagedData.some((obj) => {
      const { application, elementGroup, elementModel, elementsperVessel } = obj;
      return (application === '' || elementGroup === '' || elementModel === '' || elementsperVessel === 0);
    });
  };

  // where are we using this function??
  handleSaveRocontextTableData.calculateBalance = async () => {
    const record = rowData;
    const stagedData = record.filter((obj) => obj.pressureVessels !== 0);
    if (isEmpty(stagedData) || validateFields(stagedData)) {
      showErrorMessage();
    } else {
      stagedData.reduce((stageObject, obj, stIndex) => {
        stageObject[stIndex] = {
          num_vessels: Number(obj.pressureVessels),
          pv_param_dict: [...Array(Number(obj.pressureVessels)).keys()].reduce((result, item, pvIndex) => {
            result[pvIndex] = {
              num_elements: Number(obj.elementsperVessel),
              module_param_dict: stagedData.reduce((mpDict, value, mpIndex) => {
                mpDict[mpIndex] = {
                  element_id: '0',
                  age: obj.elementAge,
                  boost: obj.interStageBoostPressure,
                  boost_eff: obj.boostEnergyEfficiency,
                  inter_stage_dp: obj.interStagePressureLoss,
                  back_press: 0.0,
                  a_factor: obj.fluxAnnual,
                  b_factor: obj.saltPassageAnnual
                };
                return mpDict;
              }, {}),
            };
            return result;
          }, {})
        };
        return stageObject;
      }, {});
    }
  };

  // ### On click of OK button ###
  handleSaveRocontextTableData.handleSaveRoTableData = async (bg_rowdata, isModelClose) => {
    if (isShowErrorMessage) {
      localStorage.setItem('globalExitBtn', 'true');
    }
    const record = bg_rowdata;
    const stagedData = record.filter((obj) => Number(obj.pressureVessels) !== 0);
    const elementsDict = get(dbTransactionDetails, 'elements_dict', {});
    const elementsDict_numElements = {};
    const module_param_dict_1 = {};
    // Added by Akhil to iterate element dict based on highest element id not based on length
    for (let i = 1; i <= Math.max(...Object.keys(elementsDict)); i += 1) {
      if (elementsDict[i.toFixed(1)]) {
        elementsDict_numElements[elementsDict[i.toFixed(1)].strModel] = i.toFixed(1);
      }
    }
    if (isEmpty(stagedData) || validateFields(stagedData)) {
      localStorage.setItem('roapply', 0);
      showErrorMessage();
    } else {
      const stageObj = stagedData.reduce((stageObject, obj, stIndex) => {
        stageObject[stIndex] = {
          num_vessels: Number(obj.pressureVessels),
        };
        return stageObject;
      }, {});
      const stageObj_1 = stagedData.reduce((stageObject, obj, stIndex) => {
        stageObject[stIndex] = {
          num_elements: Number(obj.elementsperVessel),
        };
        return stageObject;
      }, {});
      const stageObj_iter = stagedData.reduce((stageObject, obj, stIndex) => {
        stageObject[stIndex] = Number(obj.elementsperVessel); // * Number(obj.pressureVessels);
        return stageObject;
      }, {});
      stagedData.reduce((stageObject, obj, stIndex) => {
        stageObject[stIndex] = Number(obj.pressureVessels);
        return stageObject;
      }, {});
      const stageObj_2 = stagedData.reduce((mpDict, obj, mpIndex) => {
        mpDict[mpIndex] = {
          element_id: Number(elementsDict_numElements[obj.elementModel]), // '0',
          age: parseFloat(obj.elementAge),
          boost: parseFloat(obj.interStageBoostPressure) * unitsForPressure_atm[units.pressure ? units.pressure : 'atm'],
          boost_eff: parseFloat(obj.boostEnergyEfficiency),
          inter_stage_dp: parseFloat(obj.interStagePressureLoss) * unitsForPressure_atm[units.pressure ? units.pressure : 'atm'],
          back_press: parseFloat(obj.permeatePressure) * unitsForPressure_atm[units.pressure ? units.pressure : 'atm'],
          a_value: parseFloat(obj.fluxAnnual),
          b_value: parseFloat(obj.saltPassageAnnual),
        };
        return mpDict;
      }, {});
      let count = 0;
      let val = 0;
      for (let i = 0; i < Object.keys(stageObj_iter).length; i += 1) {
        if (i > 0) {
          val = count;
          for (let j = val; j < stageObj_iter[i] + val; j += 1) {
            module_param_dict_1[j] = stageObj_2[i];
            count += 1;
          }
        } else {
          for (let j = 0; j < stageObj_iter[i]; j += 1) {
            module_param_dict_1[j] = stageObj_2[i];
            count += 1;
          }
        }
      }
      const { id } = roDetails;
      const payload = {
        split_flow: parseFloat(convertUnitValues_flow(roInputDetails.splitPermeate, units.flow, 'm3/s')),
        recovery: parseFloat(recovery),
        is_recycle_permeate: recyclePermeate,
        num_stages: stagedData.length,
        is_dapc: abFactor === '0',
        feed_press: 0.0,
        delta_temp: 0.0,
        stage_param_dict: stageObj,
        pv_param_dict: stageObj_1, // pv_param_dict_1, // stageObj_1,
        module_param_dict: module_param_dict_1,
        ro_machine: roModel
      };

      saveFormDataInLocalStorage({ record: payload, type: 'ro', id, item: 'ro_payload' });
      onElementClick('nfSplit', id);
      const data = {
        'grid-data': rowData,
        elementParameters,
        recyclePermeate,
        roTypes,
        roInputDetails,
        recovery,
        roMachine: currRoM,
      };
      saveFormDataInLocalStorage({ record: data, type: 'ro', id, item: 'ro-dict' });
      if (Number(data.recovery) > 0)
        getBorderColor(id);
      // TO DO : Check for shared file's element access when user change them
      const current_ro_stage = JSON.parse(localStorage.getItem('ro-dict'));
      const isRoFileChanged = ro_elem_shared_access(current_ro_stage.ro);
      setIsElementModelAccess(!isRoFileChanged);
      optionsABvalue = abFactor;
      localStorage.setItem('options', JSON.stringify({ abFactor: optionsABvalue }));
      localStorage.setItem('roapply', 1);
      if (isModelClose) {
        handleCloseNF();
        // for ab value factor -> update all key to true -> render default value
        /**
         * comment by chandrashekhar because RO-from data is not saved first time
         * Step: open any RO form
         * select any one `Copy RO Machine Configuration` in dropdown
         * Then select radio button `Input A-Value Factor & B-Value Factor` then click OK
         * then open RO-form change radion button `Use Element Age and Annual % Change`
         * change `Flux Annual % Change` and `Salt Passage Annual % Change` value
         * Then click ok open Ro-form value is reset
         */
        // if (isOptnAbValFctrToggled) {
        //   updateAllKeyInABFObj(); // for abValue close issue
        //   setIsOptnAbValFctrToggled(false); // for abValue close issue
        //   // update abValue factor in localtorage  : optionsABvalue
        // }
      }
    }
  };

  handleSaveRocontextTableData.checkUpdate = () => { };
  const handleChangeRecovery = (e) => {
    setIsShowErrorMessage(true);
    localStorage.setItem('globalExitBtn', 'true');

    const { value } = e.target;
    if (value > 100 || value < 0) {
      setModalOption({
        ...defaultModalOptions,
        visible: true,
        title: 'Warning',
        message: translateObject('Recovery must be in the range 0-100%'),
        yesOrNo: false,
        onNo: () => setModalOption(defaultModalOptions)
      });
      setRecovery(0);
    } else {
      setRecovery(e.target.value);
      disabledStripperAndExplorerTab();
    }
  };

  const handleClick = (e) => {
    const ID = e.target.id;
    const flag = ID.indexOf('_', 9);
    const row = Number(ID.substring(9, flag)) - 1;
    const data = rowData[row];
    // Spec file
    if (e.target.type === 'button') {
      if (data.elementModel !== '') { // to handle out of current stage
        const elementsDict = get(dbTransactionDetails, 'elements_dict', {});
        const arrData = map(elementsDict, (row) => row);
        const currStage = find(arrData, { SelectionA: data.application, SelectionB: data.elementGroup, strModel: data.elementModel });
        downLoadFlowSheetRo(currStage.flowsheet_link);
      }
    }
  };
  useEffect(() => {
    if (Number(roRadioABFactor) === 1) {
      document.querySelector('.ro-table_container #grid .row_1 #input_num1_11').setAttribute('disabled', '');
      document.querySelector('.ro-table_container #grid .row_1 #input_num1_11').closest('td').classList.add('disabled');
      document.querySelector('.ro-table_container #grid .row_1 #input_num1_12').closest('td').classList.add('disabled');
      document.querySelector('.ro-table_container #grid .row_1 #input_num1_13').closest('td').classList.remove('disabled');
    } else if (Number(roRadioABFactor) === 0) {
      document.querySelector('.ro-table_container #grid .row_1 #input_num1_11').removeAttribute('disabled');
      document.querySelector('.ro-table_container #grid .row_1 #input_num1_11').closest('td').classList.remove('disabled');
      document.querySelector('.ro-table_container #grid .row_1 #input_num1_12').closest('td').classList.add('disabled');
      document.querySelector('.ro-table_container #grid .row_1 #input_num1_13').closest('td').classList.add('disabled');
    }
  }, [roRadioABFactor]);
  return (
    <Box sx={{ width: '100%' }}>
      <div className="content-tab-panel">
        <Notification
          options={modalOption}
          handleClose={() => setModalOption(defaultModalOptions)}
        />
        <div className="ro-analysis">
          <Grid container spacing={1} className='roFormROM'>
            <Grid item xs={12}>
              <RadioButtonsGroup
                roTypes={roTypes}
                handleChangeROTypes={handleChangeROTypes}
                handleChangeInput={handleChangeInput}
                blurInputval={blurInputval}
                roInputDetails={roInputDetails}
                recyclePermeate={recyclePermeate}
                handleRecyclePermeate={handleRecyclePermeate}
                handleChangeRecovery={handleChangeRecovery}
                recovery={recovery}
                enableRecycle={enableRecycle}
                roRadioABFactor={roRadioABFactor}
                setRoRadioABFactor={setRoRadioABFactor}
                setIsShowErrorMessage={setIsShowErrorMessage}
                isOptnAbValFctrToggled={isOptnAbValFctrToggled}
                setIsOptnAbValFctrToggled={setIsOptnAbValFctrToggled}
                translateObject={translateObject}
                roDetails={roDetails}
                setOpenRoForm={setOpenRoForm}
              />
            </Grid>
            <Grid item xs={12} className="ro-table-grid no_drag">
              <div className="ro-table-component sansW4SeLig">
                <RoTable
                  checkPressureUnit={checkPressureUnit}
                  dbTransactionDetails={dbTransactionDetails}
                  elements={elements}
                  rowData={rowData}
                  handleAfterBlur={handleAfterBlur}
                  onValueChange={onValueChange}
                  handleClick={handleClick}
                  updateElementParameters={updateElementParameters}
                  gridRef={gridRef}
                  option={option}
                  colDefArr={colDefArr}
                  roDetails={roDetails}
                  enableRecyclePermeate={enableRecyclePermeate}
                  translateObject={translateObject}

                />
              </div>
            </Grid>
            {/* RO Mach start */}
            <Grid container spacing={1} className='roFormROM'>
              <Grid item xs={7} className='ro-macine-config'>
                {/* <Grid item xs={6} md={7} sm={12} className='select-rom-dropdown no_drag'>
                  <span style={{ marginRight: 8 }} className='no_drag S_Bold'>{translateObject('Copy RO Machine Configuration')}</span>
                  <Select
                    style={{ width: '35%' }}
                    id='ddItemSelect'
                    displayEmpty
                    inputProps={{ 'aria-label': 'Without label' }}
                    value={roModel}
                    name='romUnitDd'
                    fullWidth
                    onChange={onRoMDropdownChange}
                    data-testid='romunit'>
                    {roMachineDdItem.length === 0 ?
                      <MenuItem key='0' value='No options' className='ddItem'>{translateObject('No options')}</MenuItem> :
                      roMachineDdItem.map((item, ind) => (
                        <MenuItem key={ind} value={item} className='ddItem'>{item}</MenuItem>
                      ))
                    }
                  </Select>
                </Grid>
                <Grid item xs={6} md={5} sm={12}>
                  {roModel && <div className='fact-sheet S_Bold'>
                    <span>{currRoM.FactsheetLink && <a className='FactSheet no_drag' href={currRoM.FactsheetLink} target='_blank' rel="noreferrer">FactSheet-1</a>}</span>
                    <span>{currRoM.FactsheetLink2 && <a className='FactSheet no_drag' href={currRoM.FactsheetLink2} target='_blank' rel="noreferrer">FactSheet-2</a>}</span>
                    <span>{currRoM.FactsheetLink3 && <a className='FactSheet no_drag' href={currRoM.FactsheetLink3} target='_blank' rel="noreferrer">FactSheet-3</a>}</span>
                  </div>}
                  <Grid className='' style={{ lineHeight: 1.5 }}>{roModel && <div className='no_drag fact-sheet-permeate'>{translateObject('Permeate Flow Rate')}:
                    <span className='pfrunit no_drag'>{(units.flow === 'gpm' ? currRoM.ApproxPermeateflow : convertUnitValues_flow(currRoM.ApproxPermeateflow, 'gpm', units.flow)).toFixed(2)}</span>
                    <span className='S_Bold'>{units.flow === 'gpm' ? 'gpm' : units.flow}</span>
                  </div>}
                  </Grid>
                </Grid> */}
              </Grid>
              {/* Move this section to D:\winflow_project\winflow_11\src\components\ro-input\button-grid.jsx Start */}
              <Grid item xs={5}>
                <div className="design-guideline-wrapper">
                  <div onClick={designGuidline} className='design-guideline no_drag'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <g id="design_services">
                        <g id="Vector">
                          <path d="M10.8267 7.67308L11.8733 6.62642L9.37333 4.12642L8.32667 5.17308L5.56667 2.41975C5.04667 1.89975 4.2 1.89975 3.68 2.41975L2.41333 3.68642C1.89333 4.20642 1.89333 5.05308 2.41333 5.57308L5.16667 8.32642L2 11.4997V13.9998H4.5L7.67333 10.8264L10.4267 13.5798C11.06 14.2131 11.9133 13.9798 12.3133 13.5798L13.58 12.3131C14.1 11.7931 14.1 10.9464 13.58 10.4264L10.8267 7.67308ZM6.12 7.37975L3.36 4.62642L4.62 3.35975L5.46667 4.20642L4.68 4.99975L5.62 5.93975L6.41333 5.14642L7.38 6.11308L6.12 7.37975ZM11.3733 12.6397L8.62 9.88642L9.88667 8.61975L10.8533 9.58642L10.06 10.3797L11 11.3197L11.7933 10.5264L12.64 11.3731L11.3733 12.6397Z" fill="#75748B" />
                          <path d="M13.8067 4.69308C14.0667 4.43308 14.0667 4.01308 13.8067 3.75308L12.2467 2.19308C11.9333 1.87975 11.5 1.99975 11.3067 2.19308L10.0867 3.41308L12.5867 5.91308L13.8067 4.69308Z" fill="#75748B" />
                        </g>
                      </g>
                    </svg>
                    <span className='S_Regular'>{translateObject('Design Guidelines')}</span>
                  </div>
                  <div onClick={ElementAgeCalculatorfunc} className='design-guideline no_drag'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <g id="calculate">
                        <path id="Vector" d="M12.6667 2H3.33333C2.6 2 2 2.6 2 3.33333V12.6667C2 13.4 2.6 14 3.33333 14H12.6667C13.4 14 14 13.4 14 12.6667V3.33333C14 2.6 13.4 2 12.6667 2ZM8.68667 4.70667L9.39333 4L10.3333 4.94L11.2733 4L11.98 4.70667L11.04 5.64667L11.98 6.58667L11.2733 7.29333L10.3333 6.36L9.39333 7.3L8.68667 6.59333L9.62667 5.65333L8.68667 4.70667ZM4.16667 5.14667H7.5V6.14667H4.16667V5.14667ZM7.66667 10.6667H6.33333V12H5.33333V10.6667H4V9.66667H5.33333V8.33333H6.33333V9.66667H7.66667V10.6667ZM12 11.5H8.66667V10.5H12V11.5ZM12 9.83333H8.66667V8.83333H12V9.83333Z" fill="#75748B" />
                      </g>
                    </svg>
                    <span className='S_Regular'>{translateObject('Element Age Calculator')}</span>
                  </div>
                  {visibleEAC && (
                    <ElementAgeCalculator
                      visibleEAC={visibleEAC}
                      handleCloseEAC={handleCloseEAC}
                      translateObject={translateObject}
                    />
                  )}
                  {visibleDG && (
                    <DesignGuidelines
                      visibleDG={visibleDG}
                      handleCloseDG={handleCloseDG}
                      translateObject={translateObject}
                    />
                  )}
                </div>
              </Grid>
              {/* Move this section to D:\winflow_project\winflow_11\src\components\ro-input\button-grid.jsx Start */}
            </Grid>
            {/* RO Mach end */}
          </Grid>
        </div>
      </div>
    </Box>
  );
};

export default RoFeedAnalysis;
